import script from "./DynamicTaskFilter.vue?vue&type=script&setup=true&lang=js"
export * from "./DynamicTaskFilter.vue?vue&type=script&setup=true&lang=js"

import "./DynamicTaskFilter.vue?vue&type=style&index=0&id=05d8bd19&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05d8bd19"]])

export default __exports__